import { ROUTES } from "./constants";

/**
 * Builds the URL for the Published Assignment screen by replacing the `:planId`
 * placeholder in `ROUTES.SHIFT_ROTATION_PUBLISHED` with the supplied value.
 */
export const buildStationAssignmentPublishedUrl = (planId: string): string =>
  ROUTES.SHIFT_ROTATION_PUBLISHED.replace(":planId", planId);
